<template lang="html">
    <div class="">
       
        <div class="">
            <div class="singleColumnGrid">

                <txt autofocus="autofocus" label="Enter Document Name" type="text" v-model='formData.documentName' name="documentName" v-validate="'required'"
                    :classname="errors.has('documentName')" :errormsg="errors.first('documentName')" />

                <tl-select label="Document Category" labelText="name" name="documentType" :v-model="formData.documentType" :options="documentCategoryList"
                    @change="(val)=>documentTypeChanged(val)" />

            </div>
        </div>

        <div class="margin-top-25" v-if="formData.documentType == 'Add Document Category' && isUnderDocumentTypeAdd ">
            <div class="addCategoryBox">
                <div class="customSingleColumnGrid">
                    <div>
                        <txt autofocus="autofocus" label="Document Category Name" type="text" v-model='documentCategoryName' name="documentCategoryName"
                        />
                    </div>
                    <div>
                        <btn class="customBtn margin-right-18" text="Cancel" type="secondary" @click="cancel()" />
                        <btn class="customBtn" text="Add New" type="primary" @click="addNew()" />
                    </div>
                </div>
            </div>
        </div>

        <div class="margin-top-20">
            <!-- <label class="upload-Policy-text">Upload Policy Document</label> -->
            <div class="download-btn">
              <download-button></download-button>
            </div>
        </div>
        <div class="margin-top-22">
            <upload></upload>
        </div>

        <!-- <div class="margin-top-30">
            <div class="align-filters">
                <button class="filters" v-for="(item, index) in selectedSearchItems" :key="index">
                    <span> {{item.name}} </span>
                    <img src="@/assets/group-6.svg" @click="removeTag(index)" />
                </button>
            </div>
        </div>

        <div class="margin-top-28">
            <tl-search class="search-width" placeholder="Search Department/Designation/Grades" :value="searchText" @change="filterData"
            />
            <ul class="search-result" v-if="auto_suggestions && filterDataList.length">
                <li v-for="(department,index) in filterDataList" :key="index" v-on:click="itemclicked(department)">
                    <div class="threeColumnGrid">
                        <div class="empDetails">
                            <div class="empName">
                                <label>{{department.name}}</label>
                            </div>
                            <div class="empcode">
                                <label>{{department.code}}</label>
                            </div>
                            <div class="empcode">
                                <label>{{department.email}}</label>
                            </div>
                        </div>
                        <div class="role">
                            {{department.role}}
                        </div>
                    </div>
                </li>
            </ul>
            <ul class="search-result" v-else-if="auto_suggestions && !filterDataList.length">
                <li>No data Available </li>
            </ul>
        </div> -->

        <div class="margin-top-28">
            <txt label="Departments/Designations Grades" type="text" name="documentName" placeholder="" />
        </div>

        <div class="margin-top-25">
            <btn class="customBtn" text="Save" type="primary" @click="save()" />
        </div>

        <bottom-action-container>
            <template slot="end">
                <btn-grp>
                    <btn text="Back" type="secondary" @click="routeToSubStep" />
                    <!-- <btn text="Upload" type="primary" @click="upload" /> -->
                </btn-grp>
            </template>
        </bottom-action-container>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from "vuex";

    export default {
        name: "uploadPolicyDocument",
        computed: {
            ...mapState({}),
            ...mapGetters({
                orgid: "onboard/organization/orgid"
            })
        },
        data() {
            return {
            
                formData: {
                    documentName: "",
                    documentType: ""
                },
                documentCategoryName: '',
                documentCategoryList: [{ id: 1, name: "Add Document Category" }],
                selectedSearchItems: [],
                filterDataList: [],
                showTag: true,
                auto_suggestions: false,
                isUnderDocumentTypeAdd: false,
                empName: "",
                empId: "",
                searchText: "",
                departmentData: [
                    {
                        id: 1,
                        code: "TL001",
                        name: "Nelle Foster",
                        designation: "Designer",
                        department: "KJHG",
                        costcenter: "1500000",
                        reportingmgr: "Owen Pearson",
                        nooflop: "4",
                        lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
                        noofrlop: "1",
                        rlopdates: "06/05/2019"
                    },
                    {
                        id: 2,
                        code: "TL002",
                        name: "Derrick Perry",
                        designation: "Designer",
                        department: "KJHG",
                        costcenter: "1500000",
                        reportingmgr: "Owen Pearson",
                        nooflop: "4",
                        lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
                        noofrlop: "1",
                        rlopdates: "06/05/2019"
                    },
                    {
                        id: 3,
                        code: "TL003",
                        name: "Lucas Singleton",
                        designation: "Designer",
                        department: "KJHG",
                        costcenter: "1500000",
                        reportingmgr: "Owen Pearson",
                        nooflop: "4",
                        lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
                        noofrlop: "1",
                        rlopdates: "06/05/2019"
                    },
                    {
                        id: 4,
                        code: "TL004",
                        name: "James Foster",
                        designation: "Designer",
                        department: "KJHG",
                        costcenter: "1500000",
                        reportingmgr: "Owen Pearson",
                        nooflop: "4",
                        lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
                        noofrlop: "1",
                        rlopdates: "06/05/2019"
                    },
                    {
                        id: 5,
                        code: "TL001",
                        name: "Micheal Foster",
                        designation: "Designer",
                        department: "KJHG",
                        costcenter: "1500000",
                        reportingmgr: "Owen Pearson",
                        nooflop: "4",
                        lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
                        noofrlop: "1",
                        rlopdates: "06/05/2019"
                    }
                ],
                
            };
        },
        mounted() { },

        methods: {
            ...mapActions({}),

            routeToSubStep() {
                this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities` });
            },

            removeTag(index) {
                this.selectedSearchItems.splice(1, index);
                //console.log("selectedSearchItems", this.selectedSearchItems);
                this.showTag = false;
            },

            upload() { },

            selectedEmp(emp) {
                //console.log("emp sleected data", emp);
                this.empName = emp.name;
                this.empId = emp.code;
            },

            filterData(searchText) {
                if (searchText.length) {
                    this.auto_suggestions = true;
                    this.filterDataList = this.searchData(searchText, this.departmentData);
                } else {
                    this.auto_suggestions = false;
                }
            },
            searchData(key, array) {
                const final = [];
                for (let i = 0; i < array.length; i++) {
                    let searchObj = array[i].name;
                    if (
                        searchObj != null &&
                        searchObj.toLowerCase().search(key.toLowerCase()) !== -1
                    ) {
                        final.push(array[i]);
                    }
                }
                return final;
            },
            itemclicked(department) {
                //console.log("itemclicked:", department);
                this.selectedSearchItems.push(department);
                this.searchText = "";
                this.auto_suggestions = false;
            },

            cancel() { },

            addNew() {
                this.documentCategoryList.push({ id: 2, name: this.documentCategoryName });
                this.documentCategoryName = '';
                this.formData.documentType = ''
            },

            documentTypeChanged(val) {
                ////console.log("val:", val);
                this.formData.documentType = val.name;
                if (val.name == "Add Document Category") {
                    this.isUnderDocumentTypeAdd = true;
                } else {
                    this.isUnderDocumentTypeAdd = false;
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    .margin-top-20 {
        margin-top: 20px;
    }

    .margin-top-36 {
        margin-top: 3.6%;
    }

    .margin-top-30 {
        margin-top: 3%;
    }

    .margin-top-25 {
        margin-top: 2.5%;
    }

    .margin-top-22 {
        margin-top: 2.2%;
    }

    .margin-top-28 {
        margin-top: 2.8%;
    }

    .upload-Policy-text {
        object-fit: contain;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: normal;
        color: #646464;
    }

    .search-width {
        width: 29.7%;
        height: 35px;
    }

    .upload {
        width: 315px;
    }

    .align-filters {
        display: flex;
        margin: 0px 0 0 -10px;
        *:nth-child(1) {
            text-align: center;
        }
        button {
            border-radius: 100px;
            background-color: #b2f8f7;
        }
    }

    .filters {
        width: 125px;
        height: 28px;
        display: flex;
        justify-content: space-between;
        margin-left: 10px;
        *:nth-child(1) {
            margin-right: 10px;
            padding-left: 5px;
        }
        img {
            margin-top: 3px;
            margin-right: 10px;
            cursor: pointer;
        }
    }

    .search-result {
        position: absolute;
        width: 26.2%;
        background: #ffffff;
        max-height: 368px;
        border-radius: 4px;
        border: solid 1px #f7f7f7;
        overflow: auto;
        z-index: 1;
        li {
            padding: 15px;
            border-bottom: 0.5px solid #e3e3e3;
            margin-right: 0px !important;
            &:hover {
                background-color: #d6f2f2;
            }
        }
    }

    .empName label {
        font-size: 16px;
        color: #646464;
        margin-bottom: 4px;
    }

    .empcode label {
        font-size: 14px;
        color: #878787;
    }

    .filters {
        width: auto;
    }

    .search-bar {
        height: 35px;
    }

    .search-icon {
        top: 9px;
    }

    .header.header3 {
        padding-bottom: 0px;
    }

    .addCategoryBox {
        width: 45%;
        height: 150px;
        background-color: #f9f9f9;
    }

    .tl-select-dropdown {
        margin-bottom: 0px;
    }

    .customBtn {
        display: inline;
        box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
        min-height: 35px;
        min-width: 100px;
        padding: 8px;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 500;
        font-style: normal;
    }

    .customSingleColumnGrid {
        display: grid;
        grid: auto;
        grid-row-gap: 25px;
        padding: 17px;
    }

    .margin-right-18 {
        margin-right: 18px;
    }

    .tl-textfield input {
        background-color: #ffff;
    }
</style>